import React, { useMemo } from 'react';
import { Chip } from '@mui/material';
import { shortenDescription } from '../../../common/description';

function MakeEvents({ makeEvents, masterTagsData }) {
  const { activeEvents, finishedEvents } = useMemo(() => {
    const active = [];
    const finished = [];

    (makeEvents || []).forEach((event) => {
      if (event.completion_status && event.completion_status !== 'active') {
        finished.push(event);
      } else {
        active.push(event);
      }
    });

    return { activeEvents: active, finishedEvents: finished };
  }, [makeEvents]);

  const getTagLabels = (tagIds, masterTags) => {
    if (!Array.isArray(tagIds) || !masterTags) return [];

    return tagIds
      .map((id) => {
        const tag = masterTags.find((t) => t.id === Number(id));
        return tag ? tag.name : null;
      })
      .filter(Boolean);
  };

  const handleClick = (roomId) => {
    window.location.href = `/owner-console/${roomId}`;
  };

  const renderEvent = (event) => {
    const tagLabels = getTagLabels(event.tags, masterTagsData?.tags);

    return (
      <div
        key={event.id}
        onClick={() => handleClick(event.room_id)}
        style={{
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '16px',
          margin: '8px 0',
          cursor: 'pointer',
          backgroundColor: '#f9f9f9',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
          {event.completion_status && event.completion_status !== 'active' ? (
            <Chip label="終了" size="small" />
          ) : (
            <Chip label="開催中" size="small" color="success" />
          )}
          <p style={{ fontWeight: 'bold', margin: 0, fontSize: '18px' }}>{event.name}</p>
        </div>

        {tagLabels.length > 0 && (
          <div style={{ marginBottom: '8px', display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
            {tagLabels.map((label) => (
              <Chip key={label} label={label} size="small" color="primary" />
            ))}
          </div>
        )}

        <p style={{ margin: '8px 0 0 0', fontSize: '14px' }}>現在のラウンド: {event.round} ラウンド目</p>
        <p style={{ margin: '8px 0 0 0', color: '#666', fontSize: '12px' }}>{shortenDescription(event.description, 30)}</p>
      </div>
    );
  };

  return (
    <div style={{ padding: '16px' }}>
      <h3>作成中のルーム</h3>
      {activeEvents.length > 0 ? activeEvents.map((event) => renderEvent(event)) : <div>作成中のルームはありません</div>}

      <h3 style={{ marginTop: '32px' }}>終了したルーム</h3>
      {finishedEvents.length > 0 ? finishedEvents.map((event) => renderEvent(event)) : <div>終了したルームはありません</div>}
    </div>
  );
}

export default MakeEvents;
